export const LOGIN_MIN_LENGTH = 3;
export const LOGIN_MAX_LENGTH = 32;
export const LOGIN_PATTERN = /^[a-zA-Z0-9]+$/;

export function sanitizeLoginInput(value, maxLength = LOGIN_MAX_LENGTH) {
    return String(value ?? '')
        .replace(/[^a-zA-Z0-9]/g, '')
        .slice(0, maxLength);
}

export function normalizeLogin(login) {
    return sanitizeLoginInput(String(login ?? '').trim());
}

export function isValidLoginFormat(login) {
    const normalized = normalizeLogin(login);
    return normalized.length >= LOGIN_MIN_LENGTH && LOGIN_PATTERN.test(normalized);
}

export function getLoginFormatError(login) {
    const normalized = normalizeLogin(login);
    if (!normalized) {
        return 'Введите логин';
    }
    if (normalized.length < LOGIN_MIN_LENGTH) {
        return `Логин — не короче ${LOGIN_MIN_LENGTH} символов`;
    }
    if (!LOGIN_PATTERN.test(normalized)) {
        return 'Только латиница и цифры, без пробелов';
    }
    return null;
}

export const LOGIN_EXAMPLE = 'Ladybug303';

export const LOGIN_HINT_TEXT = 'Логин — не email. Только латиница и цифры, без пробелов и спецсимволов.';
